import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FiMail } from 'react-icons/fi';

const Footer = () => {
  return (
    <footer className="footer-custom">
      <Container>
        <Row className="mb-4">
          <Col md={4} className="mb-4 mb-md-0">
            <h5 className="mb-3">
              <strong>Better Business Booking</strong>
            </h5>
            <p style={{ color: 'rgba(255, 255, 255, 0.8)', lineHeight: '1.8' }}>
              Simple, affordable, and reliable appointment scheduling for businesses. 
              Streamline your bookings and grow your business.
            </p>
          </Col>

          <Col md={2} className="mb-4 mb-md-0">
            <h5 className="mb-3">Quick Links</h5>
            <ul className="list-unstyled">
              <li className="mb-2">
                <Link to="/" style={{ color: 'rgba(255, 255, 255, 0.8)' }}>Home</Link>
              </li>
              <li className="mb-2">
                <Link to="/login" style={{ color: 'rgba(255, 255, 255, 0.8)' }}>Login</Link>
              </li>
              <li className="mb-2">
                <Link to="/signup" style={{ color: 'rgba(255, 255, 255, 0.8)' }}>Sign Up</Link>
              </li>
              <li className="mb-2">
                <Link to="/dashboard" style={{ color: 'rgba(255, 255, 255, 0.8)' }}>Dashboard</Link>
              </li>
            </ul>
          </Col>

          <Col md={3} className="mb-4 mb-md-0">
            <h5 className="mb-3">Resources</h5>
            <ul className="list-unstyled">
              <li className="mb-2">
                <Link to="/terms-of-service" style={{ color: 'rgba(255, 255, 255, 0.8)' }}>Terms of Service</Link>
              </li>
              <li className="mb-2">
                <Link to="/privacy-policy" style={{ color: 'rgba(255, 255, 255, 0.8)' }}>Privacy Policy</Link>
              </li>
              <li className="mb-2">
                <a href="mailto:bbb@fringe.ltd" style={{ color: 'rgba(255, 255, 255, 0.8)' }}>Support</a>
              </li>
            </ul>
          </Col>

          <Col md={3}>
            <h5 className="mb-3">Contact Us</h5>
            <ul className="list-unstyled">
              <li className="mb-2 d-flex align-items-center">
                <FiMail className="me-2" style={{ color: 'rgba(255, 255, 255, 0.8)' }} />
                <a href="mailto:bbb@fringe.ltd" style={{ color: 'rgba(255, 255, 255, 0.8)' }}>
                  bbb@fringe.ltd
                </a>
              </li>
            </ul>
          </Col>
        </Row>

        <Row>
          <Col className="text-center pt-3" style={{ borderTop: '1px solid rgba(255, 255, 255, 0.1)' }}>
            <p style={{ color: 'rgba(255, 255, 255, 0.6)', margin: 0, marginBottom: '0.5rem' }}>
              © {new Date().getFullYear()} Better Business Booking. All rights reserved.
            </p>
            <div style={{ color: 'rgba(255, 255, 255, 0.6)' }}>
              <Link to="/terms-of-service" style={{ color: 'rgba(255, 255, 255, 0.6)', textDecoration: 'none', marginRight: '1rem' }}>
                Terms of Service
              </Link>
              <span style={{ marginRight: '1rem' }}>|</span>
              <Link to="/privacy-policy" style={{ color: 'rgba(255, 255, 255, 0.6)', textDecoration: 'none' }}>
                Privacy Policy
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
